const axios = require('axios').default;

const instance = axios.create({
    baseURL: 'https://version-api.smsmart.net'
    // baseURL: 'http://192.168.2.8:8300'
});

instance.interceptors.response.use(function (response) {
    const data = response.data
    if (data.code === 401) {
        return Promise.reject(data);
    }
    return data
}, function (error) {
    return Promise.reject(error);
});

/**
 * 查询报价
 */
export function bjQuery(params) {
    return instance.post("/h5/light/bjd/query", params)
}


/**
 * 生成报价单
 */
export function genBjd(params) {
    return instance.post("/h5/light/bjd/doc", params)
}
